"use strict";

const burger = document.querySelector(".burger");
const nav = document.querySelector(".nav");
const closeButton = document.querySelector(".nav__close");
const header = document.querySelector(".header");

if (burger && nav && closeButton) {
  burger.addEventListener("click", () => {
    nav.classList.add("is-open");
  });

  closeButton.addEventListener("click", () => {
    nav.classList.remove("is-open");
  });
}

if (header) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
}